import BaseService from "@/services/base.service";

const URL_API_SETTING = process.env.VUE_APP_URL_SETTINGS;

class SettingService extends BaseService {
    async getSettings() {
        return await this.get(`${URL_API_SETTING}/accounts.json`).then(
            ({ data }) => data
        );
    }
}

export default new SettingService();
